<script lang="ts">
    import CN from "classnames";

    let className: string | undefined = undefined;
    export { className as class };
    export let rowGap = "1.25em";
</script>

<div
    class={CN("gw-form-layout", className)}
    style={`--gw-form-layout-row-gap: ${rowGap}`}
>
    <slot />
</div>

<style lang="postcss">
    .gw-form-layout {
        display: grid;
        row-gap: var(--gw-form-layout-row-gap, 1.25em);
    }
</style>
